module.exports = __webpack_public_path__ + "static/media/interview.0a76e8b4.mp4";